const config = {
 apiKey: "AIzaSyAmXKbitQFVZYe_lnscbE_Cg7SxgufQGp4",
   authDomain: "soothe-38296.firebaseapp.com",
   projectId: "soothe-38296",
   storageBucket: "soothe-38296.firebasestorage.app",
   messagingSenderId: "716506356733",
   appId: "1:716506356733:web:400213a6a762aa34741794",
   measurementId: "G-4ND85F0MFD"
};

export default config;
